import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'

import { requestFlight } from '../../actions/flights'
import { fetchPassengers } from '../../actions/passengers'
import { v1requestSSRList } from '../../actions/ssrs'

import { isTOFlight } from '../../utils/checkIsTOFlight'

import EditBooking from '../../components/EditBooking'

interface EditBookingPropsInterface {
  match: {
    params: {
      id: string
    }
  }
}

export const mapStateToProps = (
  state: ReduxStoreInterface,
  props: EditBookingPropsInterface
) => {
  const flightId = props.match.params.id

  const isFlightLoaded =
    !state.requests.isRequestingPassengers &&
    state.flights.allIds.includes(flightId)
  const flightIsToFlight = isTOFlight(flightId)

  return {
    isTOFlight: flightIsToFlight,
    isFlightLoaded,
    departureFlightId: flightId,
    isSpecialSSRModalOpen: state.modals.isSpecialSSRModalOpen,
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  requestSSRs: (flightId: string) => {
    dispatch(v1requestSSRList(flightId))
  },
  requestFlight: (flightId: string) => {
    dispatch(requestFlight(flightId))
  },
  fetchPassengers: (flightId: string) => {
    dispatch(fetchPassengers(flightId))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditBooking)
